define('EideBaillyLLP.ProductMSRPDisplay', [
	'ProductMSRPDisplay.View',
	'Profile.Model',
	'SC.Configuration'
], function (
	ProductMSRPDisplayView,
	ProfileModel,
	Configuration
) {
	'use strict';

	return {
		mountToApp: function mountToApp(container) {
			if (!SC.isPageGenerator()) {

				try {
					/** @type {LayoutComponent} */
					var layout = container.getComponent('Layout'),
						plp = container.getComponent('PLP'),
						pdp = container.getComponent('PDP'),
						userProfile = container.getComponent('UserProfile'),
						user = ProfileModel.getInstance();

					var onlinePriceFormatted = '',
						onlinePrice = 0.00,
						customerPriceLevelRate = '',
						discountRate = '',
						userIsLoggedIn;

					userProfile && userProfile.getUserProfile().then(function (profile) {
						userIsLoggedIn = profile.isloggedin;
					});

					if (pdp) {
						var customerPriceLevel = user.get('priceLevel');
						var defaultPriceLevel = Configuration.get('siteSettings.defaultpricelevel');

						pdp.on('beforeShowContent', function () {
							//we only display the 'SRP' if the current customer price level is not the default price level
							if (customerPriceLevel != defaultPriceLevel) { //5 = Online Price
								var itemInfo = pdp.getItemInfo();								

								onlinePriceFormatted = itemInfo.item.pricelevel5_formatted;
								onlinePrice = itemInfo.item.pricelevel5;

								//calculate the discount rate
								customerPriceLevelRate = (itemInfo.item['pricelevel' + customerPriceLevel]) ? itemInfo.item['pricelevel' + customerPriceLevel] : '';
								discountRate = (customerPriceLevelRate) ? Math.round(((onlinePrice - customerPriceLevelRate) / onlinePrice) * 100) : '';

								if (onlinePriceFormatted) {
									pdp.addChildViews(
										pdp.PDP_FULL_VIEW, {
										'Product.Price': {
											'SRPDisplayView': {
												childViewIndex: 999,
												childViewConstructor: function () {
													return new ProductMSRPDisplayView({
														application: container,
														userIsLoggedIn: userIsLoggedIn,
														srp_formatted: (customerPriceLevelRate == onlinePrice) ? '' : onlinePriceFormatted,
														srp: onlinePrice,
														discount_rate: discountRate
													});
												}
											}
										}
									}
									);

									pdp.addChildViews(
										pdp.PDP_QUICK_VIEW, {
										'Product.Price': {
											'SRPDisplayView': {
												childViewIndex: 999,
												childViewConstructor: function () {
													return new ProductMSRPDisplayView({
														application: container,
														userIsLoggedIn: userIsLoggedIn,
														srp_formatted: (customerPriceLevelRate == onlinePrice) ? '' : onlinePriceFormatted,
														srp: onlinePrice,
														discount_rate: discountRate
													});
												}
											}
										}
									}
									);
								}
							} else {

							}
						});
					} //endif: pdp

					if (layout && plp) {						
						//triggers on beforeShowContent
						plp.on('beforeShowContent', function () {
							layout.addToViewContextDefinition('Cart.QuickAddToCart.View', 'srp_formatted_2', 'string', function srp_formatted_2(context) {
								var itemsInfo = plp.getItemsInfo();
								var onlinePrice_formatted = '';
								if (itemsInfo) {
									var model = _.find(itemsInfo, function (item) {
										return item.internalid == context.itemId;
									});

									if (model && model.pricelevel5_formatted) {
										//calculate the discount rate
										customerPriceLevelRate = (model['pricelevel' + customerPriceLevel]) ? model['pricelevel' + customerPriceLevel] : '';
										discountRate = (customerPriceLevelRate) ? Math.round(((model.pricelevel5 - customerPriceLevelRate) / model.pricelevel5) * 100) : '';

										layout.addChildViews(plp.PLP_VIEW, {
											'ProductViewsPrice.Price': {
												'SRPDisplayView': {
													childViewIndex: 999,
													childViewConstructor: function () {
														return new ProductMSRPDisplayView({
															application: container,
															userIsLoggedIn: userIsLoggedIn,
															srp_formatted: (customerPriceLevelRate == model.pricelevel5) ? '' : model.pricelevel5_formatted,
															srp: model.pricelevel5,
															discount_rate: discountRate
														});
													}
												}
											}
										});
									}
									onlinePrice_formatted = model.pricelevel5_formatted;
								}
								return onlinePrice_formatted;
							});
						});

						//triggers on afterShowContent
						plp.on('afterShowContent', function () {
							layout.removeToViewContextDefinition('Cart.QuickAddToCart.View', 'srp_formatted_2');
						});
					} //endif: plp
				} catch (e) {
					console.error(e);
				}
			}
		}
	};
});
